export const baseUrl = "/api"
export const APPID = "wxeee967ba25d2cb73"
// wx8081d5df8efed803, 服务号
// wx9929c914a601c8ce， 订阅号
export const REDIRECT_URI = "https://dc.caasai.com/sudiao/#/login"

export const sexList = [
  {key: '男', value: 1 },
  {key: '女', value: 2}
]
export const diplomaList = [
  '博士',
  '硕士',
  '本科',
  '专科',
  '高中',
  '初中',
  '小学',
  '其他'
]
export const apiConfigList = [
  'updateAppMessageShareData',
  'chooseImage',
  'previewImage',
  'getLocation',
  'updateTimelineShareData',
  'checkJsApi'
]